import { t } from "i18next";
import { toast } from "react-hot-toast";
import { Modal } from "ui";

import { useDeleteStaffManager, useRestoreStaffManager } from "../../../apis";
import { ChangeStaffManagerDeleteStatusModalProps } from "./ChangeStaffManagerDeleteStatusModal.types";

import styles from "./ChangeStaffManagerDeleteStatusModal.module.scss";

const DeleteStaffManagerModal = ({
  isOpen,
  id,
  action,
  onClose,
  onSuccess
}: ChangeStaffManagerDeleteStatusModalProps) => {
  const deleteStaffManager = useDeleteStaffManager({
    onSuccess: () => {
      onClose();
      toast.success(t("Manager deleted successfully"));
      onSuccess?.();
    }
  });

  const restoreStaffManager = useRestoreStaffManager({
    onSuccess: () => {
      onClose();
      toast.success(t("Manager restored successfully"));
      onSuccess?.();
    }
  });

  const onOkClick = () => {
    if (action === "Delete") {
      deleteStaffManager.mutate(id);
    } else {
      restoreStaffManager.mutate(id);
    }
  };

  return (
    <Modal
      type="delete"
      isOpen={isOpen}
      title={t(`${action} Manager`)}
      isLoading={deleteStaffManager.isLoading}
      okText={action}
      onOk={onOkClick}
      contentClassName={styles.deleteManagerModal}
      onClose={onClose}
    >
      <p className={styles.deleteManagerModal_text}>
        {t(`Are you sure you want to ${action.toLowerCase()} this manager?`)}
      </p>
    </Modal>
  );
};

export default DeleteStaffManagerModal;
